/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateIcrTouchScheduleSitesConfigData
 */
export interface CreateIcrTouchScheduleSitesConfigData {
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateIcrTouchScheduleSitesConfigData
     */
    siteNumbers: Array<number> | null;
}

/**
 * Check if a given object implements the CreateIcrTouchScheduleSitesConfigData interface.
 */
export function instanceOfCreateIcrTouchScheduleSitesConfigData(value: object): value is CreateIcrTouchScheduleSitesConfigData {
    if (!('siteNumbers' in value) || value['siteNumbers'] === undefined) return false;
    return true;
}

export function CreateIcrTouchScheduleSitesConfigDataFromJSON(json: any): CreateIcrTouchScheduleSitesConfigData {
    return CreateIcrTouchScheduleSitesConfigDataFromJSONTyped(json, false);
}

export function CreateIcrTouchScheduleSitesConfigDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIcrTouchScheduleSitesConfigData {
    if (json == null) {
        return json;
    }
    return {
        
        'siteNumbers': json['siteNumbers'] == null ? null : json['siteNumbers'],
    };
}

  export function CreateIcrTouchScheduleSitesConfigDataToJSON(json: any): CreateIcrTouchScheduleSitesConfigData {
      return CreateIcrTouchScheduleSitesConfigDataToJSONTyped(json, false);
  }

  export function CreateIcrTouchScheduleSitesConfigDataToJSONTyped(value?: CreateIcrTouchScheduleSitesConfigData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siteNumbers': value['siteNumbers'],
    };
}

